import smartSolveApi from './instances/smartsolve';

export const initiateModuleUpgrade = async () => {
  try {
    const response = await smartSolveApi.post('/InitiateModuleUpgrade', {});

    return response.data;
  } catch (e) {
    throw new Error(`initiateModuleUpgrade() failed: ${e}`);
  }
};

export const getUpgradeModules = async (moduleId) => {
  try {
    const response = await smartSolveApi.post('/ModuleUpgrade', {
      Id: moduleId,
    });

    return response.data;
  } catch (e) {
    throw new Error(`getUpgradeModules() failed: ${e}`);
  }
};

export const getUpgradeModuleStatus = async (moduleId) => {
  try {
    const response = await smartSolveApi.post('/ModuleUpgradeStatus', {
      Id: moduleId,
    });

    return response.data;
  } catch (e) {
    throw new Error(`getUpgradeModuleStatus() failed: ${e}`);
  }
};

export const getUpgradeLogPackage = async (Id) => {
  try {
    const response = await smartSolveApi.post(
      '/UpgradeLogPackage',
      {
        Id,
      },
      {
        responseType: 'blob',
      }
    );

    return response.data;
  } catch (e) {
    throw new Error(`getUpgradeModuleStatus() failed: ${e}`);
  }
};

export const resetUpgradeStatus = async (moduleId) => {
  try {
    const response = await smartSolveApi.post('/ResetUpgradeStatus', {
      Id: moduleId,
    });

    return response.data;
  } catch (e) {
    throw new Error(`resetUpgradeStatus() failed: ${e}`);
  }
};
